import { n as s } from "./property-9daa16cd.mjs";
import { r as p } from "./state-7560d4dc.mjs";
import { e as h } from "./query-d94c86d2.mjs";
import { e as r } from "./class-map-2994e95e.mjs";
import { i as x, b as v, E as g, x as i, a as b, r as y } from "./createReactComponent-58f9bea8.mjs";
import { S as k } from "./slot-controller-fa97ce97.mjs";
import { r as w } from "./icon-c572aa57.mjs";
import { r as f } from "./checkbox-46b40c6a.mjs";
import { r as _ } from "./radio-8b0e9514.mjs";
import { r as $ } from "./tooltip-cb602d1f.mjs";
var T = Object.defineProperty, L = Object.getOwnPropertyDescriptor, o = (a, e, n, l) => {
  for (var c, d = l > 1 ? void 0 : l ? L(e, n) : e, m = a.length - 1; m >= 0; m--)
    (c = a[m]) && (d = (l ? c(e, n, d) : c(d)) || d);
  return l && d && T(e, n, d), d;
}, S = ((a) => (a.STANDARD = "standard", a.CHECKBOX = "checkbox", a.NAVIGATION = "navigation", a.RADIO = "radio", a.OPTION = "option", a.RISKY = "risky", a))(S || {});
function u(a, e, n = !1) {
  let l = e;
  return l.length > a || n ? (l = `${l.substring(0, a)}...`, l) : "";
}
class t extends g {
  constructor() {
    super(...arguments), this.icon = "", this.iconVariant = "", this.iconSize = "", this.category = "", this.categoryWithoutArrow = !1, this.value = "", this.variant = "standard", this.action = !1, this.selected = !1, this.highlightText = "", this.labelText = "", this.secondaryText = "", this.prefixIconLabel = "", this.disabled = !1, this.indeterminate = !1, this.wrapSecondaryText = !1, this.dynamicWidth = !1, this.showTooltip = !1, this.showSecondaryTooltip = !1, this.slotController = new k(this, "menu-item-header"), this.getDefaultItem = () => i`<button
      class=${r({ "menu-item": !0, selected: this.selected, disabled: this.disabled, [this.getMenuFlavor()]: !0 })}
      role="menuitem"
      part="menu-item"
    >
      <div
        class=${r({ "menu-item--header": !0, hide: !this.slotController.test("menu-item-header") })}
      >
        <slot name="menu-item-header"></slot>
      </div>
      <div class="menu-item__body-wrapper">
        ${this.getIcon()}
        <div class="menu-item__content">
          <div
            class=${r({ "menu-item--body": !0, nowrap: this.nowrap })}
          >
            <slot class="menu-item--body-slot"></slot>
            ${this.getSelectIcon()}
          </div>
          <div class="menu-item__secondary-label">
            ${this.wrapSecondaryText ? this.secondaryText : this.getSecondaryText()}
          </div>
        </div>
      </div>
    </button> `, this.getActionItem = () => {
      let e;
      const n = u(80, this.innerHTML, this.nowrap);
      this.labelText = this.innerHTML;
      const l = this.wrapSecondaryText ? this.secondaryText : this.getSecondaryText();
      return e = this.variant === "checkbox" ? i`<div
        class=${r({ "menu-item action-item": !0, disabled: this.disabled, selected: this.selected, "dynamic-width": this.dynamicWidth })}
        role="menuitem"
        tabindex="0"
        part="menu-item"
      >
        ${this.dynamicWidth ? this.getCheckBoxLabelDynamically() : this.getCheckBoxLabel(n)}
        ${this.secondaryText ? i`<div
              class="menu-item__secondary-label menu-item__secondary-label--checkbox"
            >
              ${l}
            </div>` : b}
      </div>` : this.variant === "radio" ? i`<div
        class=${r({ "menu-item action-item": !0, selected: this.selected, disabled: this.disabled, "dynamic-width": this.dynamicWidth })}
        role="menuitem"
        tabindex="0"
        part="menu-item"
      >
        ${this.dynamicWidth ? this.getRadioLabelDynamically() : this.getRadioLabel(n)}
        ${this.secondaryText ? i`<div
              class="menu-item__secondary-label menu-item__secondary-label--radio"
            >
              ${l}
            </div>` : b}
      </div>` : i`<div
        class=${r({ "menu-item": !0, "action-item": !0, [this.getMenuFlavor()]: !0, selected: this.selected && this.variant !== "navigation", "navigation-selected": this.selected && this.variant === "navigation", disabled: this.disabled, "menu-item--focused": this.focused })}
        role="menuitem"
        tabindex="0"
        part="menu-item combobox-menu-item"
      >
        <div class="menu-item__body-wrapper">
          ${this.getIcon()}
          <div class="menu-item__content">
            ${this.dynamicWidth ? this.getLabelDynamically() : this.getLabel(n)}
            <div class="menu-item__secondary-label">
              ${l}
            </div>
          </div>
          ${this.getSelectIcon()}
        </div>
      </div>`, e;
    }, this.getSecondaryText = () => {
      const e = u(33, this.secondaryText);
      return this.dynamicWidth ? this.showSecondaryTooltip ? i`<ex-tooltip position="top" alignment="middle">
          <div>${this.secondaryText}</div>
          <div slot="anchor" class="menu-bar__secondary-label-tooltip">
            <label class="secondary-text-label" id="secondary-label-tooltip"
              >${this.secondaryText}</label
            >
          </div>
        </ex-tooltip>` : i`<label class="secondary-text-label" id="secondary-label"
        >${this.secondaryText}</label
      >` : e ? i`<ex-tooltip position="top" alignment="middle">
        <div>${this.secondaryText}</div>
        <div slot="anchor" class="menu-bar__secondary-label-tooltip">
          <label id="secondary-label"></label>
        </div>
      </ex-tooltip>` : this.secondaryText;
    }, this.onSelectionHandler = () => {
      const e = { value: this.value, data: this.dataset };
      this.variant === "checkbox" ? (this.selected = !this.selected, this.selected ? (this.checkBoxEl.setAttribute("checked", !0), e.checked = !0) : (this.checkBoxEl.removeAttribute("checked"), e.checked = !1)) : this.variant === "radio" ? (this.radioEl.checked = !0, this.selected = !0) : this.selected = !this.selected, this.disabled || this.dispatchCustomEvent("onItemSelect", e);
    };
  }
  getIcon() {
    return this.icon ? i`<ex-icon
        class="icon"
        icon=${this.icon}
        label=${this.prefixIconLabel}
        variant=${this.iconVariant || "default"}
      ></ex-icon>` : b;
  }
  getSelectIcon() {
    return this.selected && this.variant === "option" ? i`<ex-icon
        class="select-icon"
        part="select_icon"
        size="XS"
        icon="Check"
        variant="default"
      ></ex-icon>` : b;
  }
  getMenuFlavor() {
    return `menu--item-${this.variant}`;
  }
  checkLabelOverflow() {
    requestAnimationFrame(() => {
      var e, n, l, c;
      if (this.menuLabel) {
        const d = ((e = this.menuLabel) == null ? void 0 : e.scrollWidth) > ((n = this.menuLabel) == null ? void 0 : n.offsetWidth), m = ((l = this.menuSecondaryLabel) == null ? void 0 : l.scrollWidth) > ((c = this.menuSecondaryLabel) == null ? void 0 : c.offsetWidth);
        this.showSecondaryTooltip = m, this.showTooltip = d;
      }
    });
  }
  getLabel(e) {
    return e ? (this.labelText = e, i`<ex-tooltip
        class="tooltip-label"
        position="top"
        alignment="middle"
      >
        <div><slot></slot></div>
        <div
          slot="anchor"
          class=${r({ label: !0, nowrap: this.nowrap })}
        >
          <label id="menulabel"><slot></slot></label>
        </div>
      </ex-tooltip>`) : i`<label id="menulabel"><slot></slot></label>`;
  }
  getLabelDynamically() {
    return this.showTooltip ? i`<ex-tooltip
        class="tooltip-label"
        position="top"
        alignment="middle"
      >
        <div><slot></slot></div>
        <div
          slot="anchor"
          class=${r({ label: !0, nowrap: this.nowrap })}
        >
          <label class="label" id="menulabel"><slot></slot></label>
        </div>
      </ex-tooltip>` : i`<label class="label" id="menulabel"><slot></slot></label>`;
  }
  getCheckBoxLabel(e) {
    return e ? (this.labelText = e, i`<ex-tooltip position="top" alignment="middle">
        <div><slot></slot></div>
        <div
          slot="anchor"
          class=${r({ nowrap: this.nowrap })}
        >
          <div tabindex="-1">
            <ex-checkbox
              ?disabled=${this.disabled}
              ?indeterminate=${this.indeterminate}
              value="${this.value}"
              ><label id="menulabel"><slot></slot></label
            ></ex-checkbox>
          </div>
        </div>
      </ex-tooltip>`) : i`
      <div tabindex="-1">
        <ex-checkbox
          ?disabled=${this.disabled}
          ?indeterminate=${this.indeterminate}
          value="${this.value}"
          ><label id="menulabel"><slot></slot></label
        ></ex-checkbox>
      </div>
    `;
  }
  getCheckBoxLabelDynamically() {
    return this.showTooltip ? i`<ex-tooltip
        position="top"
        alignment="middle"
        class="tooltip-label"
      >
        <div><slot></slot></div>
        <div
          slot="anchor"
          class=${r({ nowrap: this.nowrap })}
        >
          <div tabindex="-1">
            <ex-checkbox
              ?disabled=${this.disabled}
              ?indeterminate=${this.indeterminate}
              value="${this.value}"
              ><label class="checkbox-label" id="menulabel"><slot></slot></label
            ></ex-checkbox>
          </div>
        </div>
      </ex-tooltip>` : i`
      <div tabindex="-1">
        <ex-checkbox
          ?disabled=${this.disabled}
          ?indeterminate=${this.indeterminate}
          value="${this.value}"
          ><label class="checkbox-label" id="menulabel"><slot></slot></label
        ></ex-checkbox>
      </div>
    `;
  }
  getRadioLabel(e) {
    return e ? (this.labelText = e, i` <ex-tooltip position="top" alignment="middle">
        <div><slot></slot></div>
        <div
          slot="anchor"
          class=${r({ nowrap: this.nowrap })}
        >
          <div tabindex="-1">
            <ex-radio value="${this.value} ?disabled=${this.disabled}"
              ><label id="menulabel"><slot></slot></label
            ></ex-radio>
          </div>
        </div>
      </ex-tooltip>`) : i`<div tabindex="-1">
      <ex-radio ?disabled=${this.disabled} value="${this.value}"
        ><label id="menulabel"><slot></slot></label
      ></ex-radio>
    </div>`;
  }
  getRadioLabelDynamically() {
    return this.showTooltip ? i` <ex-tooltip position="top" alignment="middle">
        <div><slot></slot></div>
        <div
          slot="anchor"
          class=${r({ nowrap: this.nowrap })}
        >
          <div tabindex="-1">
            <ex-radio value="${this.value} ?disabled=${this.disabled}"
              ><label class="radio-label" id="menulabel"><slot></slot></label
            ></ex-radio>
          </div>
        </div>
      </ex-tooltip>` : i`<div tabindex="-1">
      <ex-radio ?disabled=${this.disabled} value="${this.value}"
        ><label class="radio-label" id="menulabel"><slot></slot></label
      ></ex-radio>
    </div>`;
  }
  firstUpdated() {
    this.action && this.addEventListener("click", () => this.onSelectionHandler()), this.addEventListener("keydown", (e) => {
      e.key === "Enter" && this.onSelectionHandler();
    }), this.dynamicWidth && this.checkLabelOverflow();
  }
  updateInputElements() {
    this.variant === "checkbox" && this.checkBoxEl ? this.selected ? this.checkBoxEl.setAttribute("checked", !0) : this.checkBoxEl.removeAttribute("checked") : this.variant === "radio" && this.radioEl && (this.radioEl.checked = this.selected);
  }
  highlightLabel() {
    const e = this.labelText;
    if (e && e.length > 0 && this.highlightText.length > 0) {
      const n = this.highlightText, l = new RegExp(n, "gi");
      this.menuLabel.innerHTML = e.replace(l, "<b>$&</b>");
    } else
      this.menuLabel.innerHTML = e;
  }
  highlightSecondaryLabel() {
    if (this.secondaryText.length)
      if (this.highlightText.length > 0) {
        const e = this.highlightText, n = new RegExp(e, "gi");
        this.setSecondaryLabel(this.secondaryText.replace(n, "<b>$&</b>"));
      } else
        this.setSecondaryLabel(this.secondaryText);
  }
  updated() {
    this.action && (this.updateInputElements(), this.highlightLabel()), this.highlightSecondaryLabel();
  }
  setSecondaryLabel(e) {
    this.menuSecondaryLabel && (this.menuSecondaryLabel.innerHTML = e);
  }
  render() {
    return i`
      ${this.action ? this.getActionItem() : this.getDefaultItem()}
    `;
  }
}
t.styles = x`
    ${v(`:host{--exo-component-menu-item-label-white-space: nowrap}:host .menu-item{position:relative;padding:var(--exo-spacing-3x-small);box-sizing:border-box;cursor:pointer;transition:background-color var(--exo-time-standard) ease,border-color var(--exo-time-standard) ease;border:var(--exo-spacing-3x-small) solid transparent;border-radius:calc(.5 * var(--exo-radius-small));background-color:var(--exo-color-background);font:var(--exo-text-body-medium);color:var(--exo-color-font);outline:none;text-align:left;width:100%;display:block;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}:host .label,.secondary-text-label,.checkbox-label,.radio-label{width:100%;text-overflow:ellipsis;white-space:nowrap;display:block;overflow:hidden}:host .dynamic-width ex-checkbox::part(checkbox),:host .dynamic-width ex-checkbox::part(checkbox-label){width:100%;overflow:hidden}:host .dynamic-width ex-checkbox::part(checkbox-parent){max-width:100%}:host .dynamic-width ex-radio::part(radio),:host .dynamic-width ex-radio::part(radio-label){width:100%;overflow:hidden}:host .dynamic-width ex-radio::part(radio-parent){max-width:100%}:host .dynamic-width ex-radio{display:block}:host .menu-item:hover{background-color:var(--exo-color-background-action-hover-weak)}:host .tooltip-label .label{white-space:var(--exo-component-menu-item-label-white-space)}:host .menu-item:not(.menu-item.disabled):focus-visible,:host .menu-item--focused{background-color:var(--exo-color-background-action-hover-weak);border-color:var(--exo-color-background-action-hover)}:host .menu--item:not(.menu-item:focus-visible .menu-item.disabled):focus{background:var(--exo-color-background-action-secondary-hover)}:host .menu--item-standard:focus{background:var(--exo-color-background-action-secondary-hover)}:host .menu-item.selected:not(.menu-item.disabled),:host .menu-item.selected:focus{background-color:var(--exo-color-background-action-secondary-hover)}:host .menu-item.selected:focus-visible{border:var(--exo-spacing-3x-small) solid var(--exo-color-background-selected)!important;background-color:var(--exo-color-background-action-secondary-hover)!important}:host .menu-item .menu-item--header{margin-bottom:var(--exo-spacing-x-small);font:var(--exo-text-label-standard-bold)}:host .hide{display:none}:host label{cursor:pointer}:host .action-item{padding:var(--exo-spacing-3x-small)}:host ex-checkbox{pointer-events:none}:host ex-radio{pointer-events:none;min-height:var(--exo-spacing-x-large);padding-left:var(--exo-spacing-3x-small)}:host .menu-item__secondary-label{color:var(--exo-color-font-secondary);margin-top:var(--exo-spacing-3x-small);font:var(--exo-text-label-micro);margin-right:var(--exo-spacing-x-small)}:host .menu-item__secondary-label label b{font-weight:var(--exo-font-weight-regular)}:host .menu-bar__secondary-label-tooltip{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}:host .menu-item__secondary-label--checkbox{margin-left:calc(var(--exo-spacing-x-large) + var(--exo-spacing-3x-small))}:host .menu-item__secondary-label--radio{margin-left:var(--exo-spacing-x-large)}:host .menu-item__body-wrapper{display:flex;gap:calc(var(--exo-spacing-x-small) + var(--exo-spacing-4x-small));padding:var(--exo-spacing-2x-small) var(--exo-spacing-x-small)}:host .menu-item__body-wrapper .menu-item__content .menu-item--body{display:flex;align-items:center;gap:calc(var(--exo-spacing-x-small) + var(--exo-spacing-4x-small))}:host .menu-item__body-wrapper .icon{font-size:var(--exo-font-size-x-large);padding:var(--exo-spacing-3x-small);color:var(--exo-color-background-deselected);margin-top:var(--exo-spacing-4x-small)}:host .menu-item__content{width:90%;flex:1 0 0;min-height:calc(.3 * var(--exo-size-1));margin-top:var(--exo-spacing-3x-small);padding-right:var(--exo-spacing-medium)}:host .nowrap{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host label b{color:var(--exo-color-background-selected);font-weight:var(--exo-font-weight-semi-bold)}:host .menu--item-risky,:host .menu--item-risky .menu-item__body-wrapper .icon{color:var(--exo-color-background-danger-strong)}:host .menu--item-risky:hover,:host .menu--item-risky:focus-visible{color:var(--exo-color-background-danger-strong-hover);background:var(--exo-color-background-danger-weak)!important}:host .menu-item.menu--item-risky:focus{background:var(--exo-color-background-danger-weak)}:host .menu--item-risky:focus-visible{border:var(--exo-spacing-3x-small) solid var(--exo-color-background-danger-strong)!important}:host .menu--item-risky:hover .menu-item__body-wrapper ex-icon::part(icon),:host .menu--item-risky:not(.menu-item.disabled):focus-visible .menu-item__body-wrapper ex-icon::part(icon){color:var(--exo-color-background-danger-strong-hover)}:host ex-icon.select-icon::part(icon),:host .menu-item.selected ex-icon.icon::part(icon),.menu--item-standard:focus .menu-item__body-wrapper .icon{color:var(--exo-color-background-selected)}:host .select-icon{display:flex;align-items:center;justify-content:center;align-self:stretch;position:absolute;right:var(--exo-spacing-none);padding:var(--exo-spacing-2x-small) var(--exo-spacing-x-small) var(--exo-spacing-2x-small) var(--exo-spacing-none)}:host .menu-item.disabled:focus-visible{background:none}:host .menu-item.selected.disabled:focus-visible,:host .menu-item.menu--item-risky.disabled:focus-visible{background:none!important;border:none!important}:host .menu-item.disabled,:host .menu-item.disabled label,:host .menu-item.disabled .menu-item__secondary-label,:host .menu-item.selected.disabled ex-icon.icon::part(icon),:host .menu-item.disabled ex-icon.select-icon::part(icon),:host .menu-item.disabled .menu-item__body-wrapper .icon{pointer-events:none;color:var(--exo-color-background-disabled);border:none}:host .menu-item.menu--item-navigation{display:flex;align-items:center;padding-left:var(--exo-spacing-standard)}:host .menu-item.navigation-selected.navigation-selected{font:var(--exo-text-label-standard-semi-bold)}:host .menu-item.navigation-selected.selected:focus,:host .menu-item.navigation-selected:focus,:host .menu-item.navigation-selected.selected:not(.menu-item.disabled){background:var(--exo-color-page)}:host .menu-item.navigation-selected:before{content:"";height:var(--exo-spacing-large);border-radius:var(--exo-radius-small);background:var(--exo-color-background-selected);width:var(--exo-spacing-3x-small);position:absolute;left:calc(-1 * var(--exo-spacing-3x-small))}:host(.select__menu-item){border:var(--exo-spacing-3x-small) solid transparent;box-sizing:border-box}:host(.select__menu-item-focus-selected){border:var(--exo-spacing-3x-small) solid var(--exo-color-background-selected);background-color:var(--exo-color-background-action-secondary-hover)}:host(.select__menu-item-focused){background-color:var(--exo-color-background-action-hover-weak);border:var(--exo-spacing-3x-small) solid var(--exo-color-background-action-hover)}
`)}
  `, o([h("slot")], t.prototype, "defaultSlot", 2), o([h("#menulabel")], t.prototype, "menuLabel", 2), o([h("#secondary-label")], t.prototype, "menuSecondaryLabel", 2), o([h("ex-checkbox")], t.prototype, "checkBoxEl", 2), o([h("ex-radio")], t.prototype, "radioEl", 2), o([h(".button")], t.prototype, "button", 2), o([s()], t.prototype, "icon", 2), o([s({ attribute: "icon-variant" })], t.prototype, "iconVariant", 2), o([s({ attribute: "icon-size" })], t.prototype, "iconSize", 2), o([s({ reflect: !0 })], t.prototype, "category", 2), o([s({ type: Boolean, reflect: !0, attribute: "category-without-arrow" })], t.prototype, "categoryWithoutArrow", 2), o([s({ reflect: !0 })], t.prototype, "value", 2), o([s({ reflect: !0 })], t.prototype, "variant", 2), o([s({ type: Boolean, reflect: !0 })], t.prototype, "action", 2), o([s({ type: Boolean, reflect: !0 })], t.prototype, "selected", 2), o([s()], t.prototype, "highlightText", 2), o([p()], t.prototype, "labelText", 2), o([s({ attribute: "secondary-text" })], t.prototype, "secondaryText", 2), o([s()], t.prototype, "prefixIconLabel", 2), o([s({ type: Boolean })], t.prototype, "focused", 2), o([s({ type: Boolean, reflect: !0 })], t.prototype, "nowrap", 2), o([s({ type: Boolean })], t.prototype, "disabled", 2), o([s({ type: Boolean })], t.prototype, "indeterminate", 2), o([s({ type: Boolean })], t.prototype, "wrapSecondaryText", 2), o([s({ type: Boolean })], t.prototype, "dynamicWidth", 2), o([p()], t.prototype, "showTooltip", 2), o([p()], t.prototype, "showSecondaryTooltip", 2);
const M = (a = "") => {
  y("ex-menu-item", t, a), w(a), f(a), _(a), $(a);
};
export {
  S as M,
  t as a,
  M as r
};
